<template>
  <div>
    <h2 class="heading-3">
      {{ i18n(deliveryTitle) }}
    </h2>
    <RevCard
      class="mt-16 flex flex-col items-start gap-5 p-24 lg:flex-row lg:items-center lg:justify-between lg:gap-6"
      data-qa="shippingAddressSummary"
    >
      <Address
        key="shipping-address"
        :address="deliveryAddress"
        :with-details="!props.collectionPoint"
        with-phone
      />

      <RevButton
        data-qa="editShippingAddress"
        :icon="IconEdit"
        size="small"
        type="button"
        variant="secondary"
        @click="emit('edit-shipping')"
      >
        {{ i18n(deliveryEditButton) }}
      </RevButton>
    </RevCard>

    <h2 class="heading-3 mt-56">
      {{ i18n(translations.billingAddressTitle) }}
    </h2>
    <RevCard
      class="mt-16 flex flex-col items-start gap-5 p-24 lg:flex-row lg:items-center lg:justify-between lg:gap-6"
      data-qa="billingAddressSummary"
    >
      <Address key="billing-address" :address="billingAddress" with-details />
      <RevButton
        data-qa="editBillingAddress"
        :icon="IconEdit"
        size="small"
        type="button"
        variant="secondary"
        @click="emit('edit-billing')"
      >
        {{ i18n(translations.billingAddressEditButton) }}
      </RevButton>
    </RevCard>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import Address from '@backmarket/nuxt-module-address/Address.vue'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { IconEdit } from '@ds/icons/IconEdit'

import translations from './Addresses.translations'

const i18n = useI18n()

type AddressList = ApiSpecs['/bm/cart']['GET']['response']['addressList']

const props = defineProps<{
  collectionPoint: AddressList['deliverCollectionPoint']
  shippingAddress: NonNullable<AddressList['deliver']>
  billingAddress: NonNullable<AddressList['bill']>
  items: CartItem[]
}>()

const emit = defineEmits<{
  (e: 'edit-shipping'): void
  (e: 'edit-billing'): void
}>()

const deliveryAddress = computed(() => {
  return props.collectionPoint || props.shippingAddress
})

const deliveryTitle = computed(() => {
  return props.collectionPoint
    ? translations.collectionPointAddressTitle
    : translations.shippingAddressTitle
})

const deliveryEditButton = computed(() => {
  return props.collectionPoint
    ? translations.collectionPointAddressEditButton
    : translations.shippingAddressEditButton
})
</script>
